import Button from "@vapor/react-material/Button";
import Dialog from "@vapor/react-material/Dialog";
import DialogTitle from "@vapor/react-material/DialogTitle";
import DialogContent from "@vapor/react-material/DialogContent";
import DialogContentText from "@vapor/react-material/DialogContentText";
import DialogActions from "@vapor/react-material/DialogActions";
import Divider from "@vapor/react-material/Divider";
import IconButton from "@vapor/react-material/IconButton";
import { Xmark } from "@vapor/react-icons";

export const ConfirmationDialog = ({
  cancelButtonColor,
  cancelButtonText,
  cancelButtonVariant,
  confirmButtonColor,
  confirmButtonText,
  confirmButtonVariant,
  content,
  dividerVariant,
  handleDialogClose,
  handleDialogConfirm,
  open,
  title,
}) => {
  return (
    <Dialog
      aria-describedby="alert-dialog-description"
      aria-labelledby="alert-dialog-title"
      onClose={handleDialogClose}
      open={open}
    >
      <DialogTitle style={{ width: "500px" }}>
        {title}
        <IconButton color="primary" onClick={handleDialogClose}>
          <Xmark />
        </IconButton>
      </DialogTitle>
      <Divider variant={dividerVariant} />
      <DialogContent style={{ width: "500px" }}>
        <DialogContentText style={{ fontSize: "16px", lineHeight: "24px" }}>
          {content}
        </DialogContentText>
      </DialogContent>
      <DialogActions style={{ width: "500px" }}>
        <Button
          color={cancelButtonColor}
          onClick={handleDialogClose}
          variant={cancelButtonVariant}
        >
          {cancelButtonText}
        </Button>
        <Button
          color={confirmButtonColor}
          onClick={handleDialogConfirm}
          variant={confirmButtonVariant}
        >
          {confirmButtonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
